<!-- JAVASCRIPT START -->
<script>
  import { createEventDispatcher } from 'svelte';
  import { fade } from 'svelte/transition';
  import Toggle from '../shared/Toggle.svelte';
  import ModalContent from '../shared/ModalContent.svelte';
  import Modal from '../shared/Modal.svelte';
  import jQuery from 'jquery';

  const dispatch = createEventDispatcher();
  
  ////////////////
  // Variables
  ////////////////
  export let showPricing = true;
  export let views;
  export let priceTally;
  export let GATrackingID;
  export let GAUrlPath;
  export let previousStep;

  let formSubmitted = false;
  let finalPrice = priceTally.usd;
  let formFields = [
    {
      "id" : 1,
      "placeholder" : "Full name",
      "type" : "text",
      "required" : true,
      "value" : ""
    },
    {
      "id" : 2,
      "placeholder" : "Email",
      "type" : "email",
      "required" : true,
      "value" : ""
    },
    {
      "id" : 3,
      "placeholder" : "Phone",
      "type" : "text",
      "required" : false,
      "value" : ""
    },
    {
      "id" : 4,
      "placeholder" : "Company name",
      "type" : "text",
      "required" : false,
      "value" : ""
    },
    {
      "id" : 5,
      "placeholder" : "Job title",
      "type" : "text",
      "required" : false,
      "value" : ""
    },
    {
      "id" : 6,
      "placeholder" : "Preferred installation timeframe (optional)",
      "emailPlaceholder" : "Preferred installation timeframe",
      "type" : "select",
      "required" : false,
      "options" : [
        "1-3 months",
        "4-6 months",
        "Next year"
      ],
      "value" : ""
    }
  ];

  let today = (new Date()).toISOString().split('T')[0];
  let customerMessageIntro = `<p>Thank you for reaching out to Hamilton Storage. Please keep this email as a record of your configuration. You submitted the following details on ${today}:`;
  let adminMessageIntro = `<p>The following details were submitted on ${today}:`;

  function getContactDetails() {
    let list = `<ul>`;

    formFields.forEach(function(field){
      list += `<li><strong>${field.emailPlaceholder ? field.emailPlaceholder : field.placeholder}</strong>: ${field.value}</li>`;
    });

    list += `</ul>`;
    return list;
  }

  function getConfigHTMLTable() {
    let table = `<br>
      <h3>Configuration Summary</h3>
      <table style="border-collapse: collapse; border: 1px solid #F5F5F5; width: 100%;">
    `;

    views.forEach(function(view){
			
			view.cart.forEach(function(lineItem){	
        if(lineItem.price === 0){
          var formattedPrice = '(included)';
          console.log(formattedPrice);
        }
        else {
          var formattedPrice = formatPrice(lineItem.price);
          console.log(formattedPrice);
        }

        if(showPricing){
          table += `
            <tr>
              <td width="70%" style="padding: 8px; border: 1px solid #F5F5F5; border-right: none;">${lineItem.name}</td>
              <td width="30%" style="padding: 8px; border: 1px solid #F5F5F5; border-left: none; text-align: right;">${formattedPrice}</td>
            </tr>
          `;
        }
        else {
          table += `
            <tr>
              <td width="100%" style="padding: 8px; border: 1px solid #F5F5F5; border-right: none;">${lineItem.name}</td>
            </tr>
          `;
        }
			});

    });

    //grand total
    if(showPricing){
      table += `
        <tr>
          <td colspan="2" style="padding: 8px; background: #F5F5F5; text-align: right;">${finalPrice}</td>
        </tr>
      </table>
      `;
    }
    
    return table;
    
  }

  function getEmailMessage(message) {
    return `<!doctype html><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head><title></title><!--[if !mso]><!-- --><meta http-equiv="X-UA-Compatible" content="IE=edge"><!--<![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1"><style type="text/css">#outlook a { padding:0; } .ReadMsgBody { width:100%; } .ExternalClass { width:100%; } .ExternalClass * { line-height:100%; } body { margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%; } table, td { border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt; } img { border:0;height:auto;line-height:100%; outline:none;text-decoration:none;-ms-interpolation-mode:bicubic; } p { display:block;margin:13px 0; }</style><!--[if !mso]><!--><style type="text/css">@media only screen and (max-width:480px) { @-ms-viewport { width:320px; } @viewport { width:320px; } }</style><!--<![endif]--><!--[if mso]> <xml> <o:OfficeDocumentSettings> <o:AllowPNG/> <o:PixelsPerInch>96</o:PixelsPerInch> </o:OfficeDocumentSettings> </xml> <![endif]--><!--[if lte mso 11]> <style type="text/css"> .outlook-group-fix { width:100% !important; } </style> <![endif]--><style type="text/css">@media only screen and (min-width:480px) { .mj-column-per-100 { width:100% !important; max-width: 100%; } }</style><style type="text/css">@media only screen and (max-width:480px) { table.full-width-mobile { width: 100% !important; } td.full-width-mobile { width: auto !important; } }</style></head><body style="background-color:#F2F2F2;"><div style="background-color:#F2F2F2;"><!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="Margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;vertical-align:top;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><![endif]--><!-- HEADER --><!--[if mso | IE]><tr><td class="" width="600px" ><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="background:#fff;background-color:#fff;Margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fff;background-color:#fff;width:100%;"><tbody><tr><td style="border-bottom:10px solid #0B497A;direction:ltr;font-size:0px;padding:20px 0;text-align:center;vertical-align:top;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]--><div class="mj-column-per-100 outlook-group-fix" style="font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;"><table align="left" border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:152px;"><img height="21" src="https://web.hamiltonsupport.com/uploads/campaign/Email/consumables/hamilton-logo@2x.png" style="border:0;display:block;outline:none;text-decoration:none;height:21;width:100%;" width="152"></td></tr></tbody></table></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table></td></tr><![endif]--><!-- INTRO --><!--[if mso | IE]><tr><td class="" width="600px" ><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="background:#fff;background-color:#fff;Margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fff;background-color:#fff;width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;vertical-align:top;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]--><div class="mj-column-per-100 outlook-group-fix" style="font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;"><div style="font-family:Helvetica;font-size:16px;line-height:130%;text-align:left;color:#808080;">${message}</div></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><![endif]--></div></body></html>`;
  }

  function submitHandler(){

    //jQuery no conflict with Svelte
    var $jq = jQuery.noConflict(true);

    //mesage parts
    let contactDetails = getContactDetails();
    let configTable = getConfigHTMLTable();

    let customerSubject = `Hamilton Storage - Verso Q20 Configurator Website Inquiry`;
    let adminSubject = `Verso Q20 Configurator Website Inquiry - ${formFields[0].value}`;
    
    let htmlEmailRenderedImage = '<img src="https://q20configurator.hamiltoncompany.com/img/baseSystem--hero.jpg" style="width: 100%; height: auto;"><br><br>';

    let htmlEmailMessageCustomer = getEmailMessage(`${htmlEmailRenderedImage}${customerMessageIntro}${contactDetails}${configTable}`);
    let htmlEmailMessageAdmin = getEmailMessage(`${adminMessageIntro}${contactDetails}${configTable}`);

    //submit ajax request
    $jq.ajax({
        type: 'POST',
        url: 'https://web.hamiltonsupport.com/tools/q20configurator-tools/send-email.php',
        data: {
          userData: JSON.stringify(formFields),
          htmlEmailMessageAdmin: htmlEmailMessageAdmin,
          htmlEmailMessageCustomer: htmlEmailMessageCustomer,
          customerSubject: customerSubject,
          adminSubject: adminSubject
        },
        dataType: 'json'
    })
    .done( function( data ) {
        console.log(data);

        if(data.statusCode === 202){
          //track page view

          gtag('config', GATrackingID, {
            'title' : 'Configuration submitted',
            'page_location' : GAUrlPath + 'configurationSubmitted',
            'page' : GAUrlPath + 'configurationSubmitted'
          });

          console.log("Form successfully submitted!");
          formSubmitted = true;
          window.scrollTo(0, 0);
        }
    })
    .fail( function( data ) {
        console.log('Form submission failed ;(');
        console.log(data);
    });
    
  }

  function formatPrice(num){
		let formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 0
		});

		return formatter.format(num);
  }

</script>
<!-- JAVASCRIPT END -->





<!-- STYLES START -->
<style>
  
  .button {
    font-family: Camphor W01 Bold;
    text-transform: uppercase;
  }

  .button.blue {
    background: #1F74B8;
  }

  .button.transparent {
    color: #1F74B8;
  }

  .button:focus {
    @apply border-blue-500 !important;
    outline: none;
    box-shadow: 0 0 5px rgba(81, 203, 238, 1);
  }

  .button:hover {
    @apply border-gray-500 transition duration-100 ease-in;
  }

  .active {
    @apply border-blue-500;
  }

  @media (min-width: 1024px) { 
    .bg {
      background-image: url(/img/purchaseOptions--hero@3x.jpg);
      height: 100%;
      width: 100%;
      background-size: cover;
      background-position: center;
      animation: zoomin 2s ease-out;
      animation-fill-mode: forwards;
    }
    
    @keyframes zoomin {
      0% {
        opacity: 0;
        transform: scale(1.1);
      }
      100% {
        opacity: 1;
        transform: scale(1);
      }
    }

    .title {
      font-family: Camphor W01 Bold;
    }

    header {
      background: linear-gradient(177.21deg, #005397 0.77%, #00467f 76.64%);
    }
  }

  .nav {
    background: linear-gradient(190.51deg, rgba(54, 137, 204, 0.95) 46.75%, rgba(31, 116, 184, 0.95) 82.08%);
  }

  .blueButton {
    font-family: Camphor W01 Bold;
    box-shadow: 0px 8px 8px rgba(31, 116, 184, 0.2);
    background: #1F74B8;
  }
</style>
<!-- STYLES END -->



<!-- HTML START -->
<div class="lg:h-full lg:overflow-y-hidden">
	<div class="relative z-10 lg:h-full lg:overflow-y-scroll">
    <div class="flex flex-col text-lg lg:flex-row lg:flex-no-wrap lg:w-100 lg:min-h-full">
      <div class="lg:flex-1">

        <div class="relative overflow-hidden lg:h-full lg:w-full">
          <div class="absolute top-0 left-0 bg"></div>
        </div>

        <div class="relative lg:hidden">
          <img class="w-full md:w-1/2 md:m-auto md:mt-10" src="/img/baseSystem--hero.jpg" alt="Verso Q20 rendering">
          <button class="absolute inset-x-0 bottom-0 w-8/12 px-6 py-2 mx-auto mb-4 text-base text-white rounded-full blueButton" on:click={() => dispatch('handleStepBack', {stepName: 1})}>
              <i class="fal fa-long-arrow-left"></i> Back to {previousStep}
            </button>
        </div>
      
      </div>
      <div class="flex-1">
        <div class="max-w-screen-sm px-10 mb-12 bg-white lg:mx-auto">

          {#if formSubmitted}
            <h2 class="p-8 pb-0 text-3xl text-center text-gray-800 title">We'll be in touch!</h2>  
            <p class="py-6 text-base text-center text-gray-600">Thank you for requesting a final quote. Our team will respond to your request shortly.</p>
            <button class="flex items-center justify-center w-full py-2 button transparent px-14" type="submit" on:click={() => dispatch('handleStepBack', {stepName: 0})}>
              <i class="mr-3 text-xs font-bold far fa-redo"></i> Start Over
            </button>
          {:else}
            <h2 class="p-8 pb-0 text-3xl text-center text-gray-800 title">Finalize Quote Request</h2>
            <p class="py-6 text-base text-center text-gray-600">Submit this configuration to one of our system experts to receive more details and a final quote from Hamilton Storage.</p>

            <form on:submit|preventDefault={submitHandler}>
              {#each formFields as field, i (field.id)}

                {#if field.type == 'text'}
                  <input type="text" placeholder="{field.placeholder}" class="w-full px-2 py-2 my-3 text-base border-2 border-gray-400 rounded-sm" bind:value={formFields[i].value} required={field.required}>
                {:else if field.type == 'email'}
                  <input type="email" placeholder="{field.placeholder}" class="w-full px-2 py-2 my-3 text-base border-2 border-gray-400 rounded-sm" bind:value={formFields[i].value} required={field.required}>
                {:else if field.type == 'select'}
                  <p class="text-sm text-gray-600">{field.placeholder}</p>
                  <select class="w-full px-2 py-2 mb-3 text-base border-2 border-gray-400 rounded-sm" bind:value={formFields[i].value} required={field.required}>
                    <option value="">-Select One-</option>
                    {#each field.options as option, i}
                    <option value="{option}">{option}</option>
                    {/each}
                  </select>
                {/if}
              {/each}
              <button class="w-full py-4 mt-3 text-white rounded-full button blue px-14" type="submit">Submit</button>
              <button class="flex items-center justify-center p-2 mx-auto mt-3 button transparent px-14" type="submit" on:click={() => dispatch('handleStepBack', {stepName: 0})}>
                <i class="mr-3 text-xs font-bold far fa-redo"></i> Start Over
              </button>
            </form>
          {/if}

          <h2 class="p-8 pb-0 text-3xl text-center text-gray-800 title">Configuration Summary</h2>

          <table class="w-full text-gray-600 border table-auto">
            <tbody>
              {#each views as view, i}
                
                {#each view.cart as lineItem, j}
                  <tr>
                    {#if showPricing}
                      <td class="px-4 py-2 text-left border-b">{lineItem.name}</td>
                      <td class="px-4 py-2 text-right border-b">
                        {#if lineItem.price === 0}
                          (included)
                        {:else}
                          {formatPrice(lineItem.price)}
                        {/if}
                      </td>
                    {:else}
                      <td colspan="2" class="px-4 py-2 text-left border-b">{lineItem.name}</td>
                    {/if}
                  </tr>
                {/each}
                
              {/each}
            </tbody>
            {#if showPricing}
              <tfoot>
                <tr class="bg-gray-200">
                  <th colspan="2" class="px-4 py-2 text-right text-gray-700 uppercase" style="font-family: Camphor W01 Bold;">Total {finalPrice}</th>
                </tr>
              </tfoot>
            {/if}
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- HTML END -->